import * as PIXI from "pixi.js";
import { gsap } from "gsap";

import Display from "../responsive/Display.js";
import Library from "../utils/Library.js";
import SpriteResponsive from "../responsive/SpriteResponsive.js";
import AnimatedSpriteResponsive from "../responsive/AnimatedSpriteResponsive.js";
import SpriteReactive from "../responsive/SpriteReactive.js";
import Events from "../events/Events.js";
import Utils from "../utils/Utils.js";
import GraphicsResponsive from "../responsive/GraphicsResponsive";
import BackgroundMultiplyResponsive from "../components/BackgroundMultiplyResponsive";
import User from "../utils/User";
import AnimatedSpriteReactive from "../responsive/AnimatedSpriteReactive";
import Rain from "../responsive/animations/Rain";

export default class Environment extends PIXI.Container
{

    get GOAL_DISTANCE () { return (window.innerHeight * 200) / 1024; }

    static get BOTTOM_RESPONSIVE_SCALE_TO_SCREEN ()
    {

        return {
            params:
                {
                    x: {gravity: 0.5, using: "width"},
                    y: { gravity: 1, using: "height"}
                },

            screen:
                {
                    scale:"fillscreen"
                },

            anchor:
                {
                    x: 0.5,
                    y: 1
                }
        }
    };

    constructor ()
    {
        super();

        this.mode = "";
        this.allAssets = [];
        this.arrCurrentElements = [];
        this.backgrounds = [];
        this.objBackground = [];
        this.bReplace = false;

        this.objEmotions = {joy:[], calm:[], fear:[], anger:[]}
        this.currentEmotion = "default";

        this.objNamedElements = {};
        this.activeElement = null;
        this.xOffset = 0;
        this.sceneOffset  = {
            "foret-intro": 0,
            "foret-1": 1,
            "foret-2": 2,
            "foret-3": 3,
            "foret-4": 4,
            "foret-5": 5,
            "foret-6": 6,
        }


        this.createClosure();
    }

    createClosure ()
    {
        this.fctEmitIntroComplete = this.emitIntroComplete.bind(this);
        this.fctShowInstructionsMaestro = this.showInstructionsMaestro.bind(this);
        this.fctEmitMaestroMagic = () => this.emit(Events.MaestroMagic);
        this.fctEmitGoodAnswerAnimationComplete = () => this.emit(Events.GoodAnswerAnimationComplete);
        this.fctShowGameUI = () => this.emit(Events.ShowGameUI);
        this.fctEmitTalkComplete = () => this.emit(Events.TalkComplete);
        this.fctReplaceComplete = this.onReplaceComplete.bind(this);

        this.fctOnSceneShown = this.onSceneShown.bind(this);
    }

    replaceOffsetAfterResize ()
    {
        this.x = this.xOffset * -Display.instance.getWidth()
    }

    showScene (strScene, strDone = "")
    {
        if (strScene === "")
            return;

        let moveOffset = this.sceneOffset[strScene];


        if (moveOffset != this.xOffset)
        {
            if (moveOffset === 1)
            {
                this.anim.visible = false;
            }

            gsap.to(this, {duration: 1, x: moveOffset * -Display.instance.getWidth(), onComplete: () => this.fctOnSceneShown(strScene, strDone)});

            this.xOffset = moveOffset;

        }
    }

    updateSceneAndCharacter (decor, character)
    {

    }
    replaceScene (scene, callbackDone, callbackCleared)
    {

        let startLoadingIn = this.removeAllItems();
        this.bReplace = true;

        setTimeout( () => this.startLoadingScene(scene, callbackDone, callbackCleared), startLoadingIn);
    }

    replaceCharacter (character, callback)
    {

        //this.removeCharacter();


        setTimeout( () => this.startLoadingCharacter(character, callback), 10);
    }

    startLoadingCharacter (character, callback)
    {

        this.emit(Events.LoadCharacter, character, callback);

    }
    startLoadingScene (scene, callbackDne, callbackCleared)
    {

        this.x = 1 * -Display.instance.getWidth(); //reposition to the first scene

        if (callbackCleared)
        {
            callbackCleared();
        }

        this.layout();

        this.allAssets = [];
        this.emit(Events.LoadScene, scene, callbackDne);

    }
    removeAllItems ()
    {
        let max = 0;
        for (let i = 0; i < this.arrCurrentElements.length; i++)
        {
            let sp = this.arrCurrentElements[i];

            if (sp instanceof AnimatedSpriteResponsive)
            {
                let a = 1;

                if (sp.parent)
                {
                    sp.parent.removeChild(sp);
                }

                document.removeEventListener(Events.PlayCharacterAnimation, sp.fct1);
                document.removeEventListener(Events.BounceCharacterIn, sp.fct2)
                document.removeEventListener(Events.BounceCharacterOut, sp.fct3)

            }

            if (sp && sp.parent)
            {
                let delay = 100 + Math.random() * 2000;

                if (delay > max)
                    max = delay;

                if (sp.removeIn)
                {
                    sp.removeIn(delay)
                }
                else
                {
                    let a = 1;
                }
            }
        }

        return max + 1000;

        //setTimeout( () =>  console.log("removeAllItemsComplete"), max + 1000 ); //removeIn has a fade out of 1000ms

    }

    onSceneShown (scene, done)
    {

        //this.emit(Events.SceneShown, strDone);
        document.dispatchEvent(new CustomEvent(Events.SceneShown, {detail: {scene, done}}));
        //document.dispatchEvent(new CustomEvent(Events.SceneShown, {detail: {scene, done}}));
    }

    emitIntroComplete ()
    {
        //this.emit(Events.IntroComplete);
    }

    getDraggables ()
    {
        return this.getFilteredNameElement("Draggable");
    }

    getAnimals ()
    {
        return this.getFilteredNameElement("Animal");
    }

    findCloserAnimal (draggable)
    {
        let smallerDistance = Number.POSITIVE_INFINITY;
        let closerAnimal = null;
        let arrAnimals = this.getAnimals();

        let ptDraggable = draggable.getCenter();


        for (let i = 0; i < arrAnimals.length; i++)
        {
            let spAnimal = arrAnimals[i].sp;
            let ptCenter = spAnimal.getCenter();

            let distance = Utils.distance(ptCenter, ptDraggable);

            if (distance < smallerDistance)
            {
                smallerDistance = distance;
                closerAnimal = spAnimal;
            }

        }

        return closerAnimal;
    }

    addElements (arrElements)
    {
        for (let i = 0; i < arrElements.length; i++)
        {
            let element = arrElements[i];
            let texture = this.getTexture(element);

            if (texture || (element.type === "container") || element.type === "class")
            {
                let sp = this.getSprite(texture, element);
                this.addChild(sp);

                if (element.name)
                {
                    this.objNamedElements[element.name] = sp;
                    sp.name = element.name;
                }

                this.arrCurrentElements.push(sp);

                // sp.enableDrag();
            }


        }
    }

    animate (_strName, _strAnim, params = null)
    {
        let sp = this.getElementByName(_strName);
        let fct = sp[_strAnim].bind(sp, params);

        fct();

        return sp;
    }

    getElementByName (_strName)
    {

        return this.objNamedElements[_strName];
    }

    getFilteredNameElement (_startWith)
    {
        let arrKeys = Object.keys(this.objNamedElements);

        let arrFiltered = [];

        for (let i = 0; i < arrKeys.length; i++)
        {
            let key = arrKeys[i];

            if (key.indexOf(_startWith) !== -1)
            {
                arrFiltered.push({key, sp:this.objNamedElements[key]});
            }
        }

        return arrFiltered;
    }

    /**
     * Get current seaweed and sealion. Is primarely used for tutorial to show hand drag for one to another
     */
    getCurrentAssets ()
    {
        return this.activeElement;
    }



    setCurrentElements (assets)
    {
        this.activeElement = assets;
    }

    defineCurrentElements (item)
    {
        console.log("Environnement.defineCurrentElements This should ne defined in child class");
    }

    getAnimation (element)
    {
        let strType = element.type;
        if (strType === "animation")
        {
            let texture =  Library.instance.getTexture(element.key);

            let anim = texture.animations[element.animation];

            return anim;
        }

        return null;
    }

    getTexture (element)
    {
        let strType = element.type;
        if (strType === "atlas-texture")
        {
            return  Library.getTextureFromAtlas(element.atlas,element.key);
        }
        else if (strType === "animation")
        {
            let texture =  Library.instance.getTexture(element.key);

            let anim = texture.animations[element.animation];

            return anim;
        }

        return null;
    }

    getSprite (texture, element)
    {
        let strType = element.type;


        if (strType === "animation")
        {
            let anim = new AnimatedSpriteResponsive(texture, element);

            anim.animationSpeed = element.fps / 60;
            anim.play();


            return anim;
        }

        return new SpriteResponsive(texture, element);
    }

    removeCurrent ()
    {
        for (let i = 0; i < this.arrCurrentElements.length; i++)
        {
            let sp = this.arrCurrentElements[i];
            this.removeChild(sp);

        }
    }

    showIntro ()
    {
        this.txt.text = "ENV FOR INTRO";

        this.layout();
    }

    showSplash ()
    {

        this.txt.text = "ENV FOR SPLASH";

        this.layout();
    }

    startGame ()
    {
        //console.log("Environement.startGame. THIS SHOULD BE HANDLE IN THE CHILD CLASS")
    }



    layout ()
    {
        let width = Display.instance.getWidth();
        let height = Display.instance.getHeight();


        for (let i = 0; i < this.arrCurrentElements.length; i++)
        {
            this.arrCurrentElements[i].layout(width, height);
        }

        //this.x = this.xOffset * -width;

        this.emit(Events.Layout);

    }

    playNextDraggable (audioItem, bAddParticle = false)
    {
        console.log("Environnement.playNextDraggable should be handled in child class")
    }


    onDraggableMove (draggable)
    {
        console.log("Environnement.onDraggableMove should be handle in child class")
    }

    onDraggableRelease (draggable)
    {
        console.log("Environnement.onDraggableRelease should be handle in child class")
    }

    convertToResponsive (data)
    {
        return {
            params:
                {
                    x: {gravity: data.gravity.x, using: "width"},
                    y: { gravity: data.gravity.y, using: "height"}
                },

            scale: data.scale,
            anchor: data.anchor
        }
    }


    tweenBGColor (strHex, duration = 1000)
    {
        let r = parseInt(strHex.substring(0, 2), 16);
        let g = parseInt(strHex.substring(2, 4), 16);
        let b = parseInt(strHex.substring(4, 6), 16);

        let color = `rgba(${r},${g},${b},1)`;
        gsap.to(this, {duration: duration / 1000, tintBG: color});
    }

    get tintBG ()
    {
        return this.rgbTintBGCOlor;
    }

    set tintBG (color)
    {

        this.rgbTintBGCOlor = color;

        let splitColor = gsap.utils.splitColor(color);
        let strColor = "0x" + splitColor[0].toString(16)  + splitColor[1].toString(16)  + splitColor[2].toString(16);
        let iColor = parseInt(strColor, 16);
        this.backgroundColor.tint = iColor;
    }

    changeEmotion (emotion, duration = 0)
    {

        if (emotion === "sadness")
        {
            emotion =  "anger";
        }

        if (this.currentEmotion !== "default")
        {
            let arrSpEmotions = this.objEmotions[this.currentEmotion];

            for( let i = 0; i <  arrSpEmotions.length; i++)
            {
                let sp = arrSpEmotions[i];
                sp.visible = false;
                sp.alpha = 0;
            }
        }

        //change all elements tint
        for (let i = 0; i < this.arrCurrentElements.length; i++)
        {
            let sp = this.arrCurrentElements[i];

            if (sp && sp.changeEmotion)
            {
                sp.changeEmotion(emotion, 4);
            }
        }

        this.currentEmotion = emotion;

        if (this.currentEmotion !== "default")
        {
            let arrSpEmotions = this.objEmotions[this.currentEmotion];

            for( let i = 0; i <  arrSpEmotions.length; i++)
            {
                let sp = arrSpEmotions[i];
                sp.visible = true;
                 sp.alpha = 0;
                 sp.fadeIn();
            }
        }
    }

    onCharacterCreated (character, callback)
    {

        let type = "character";
        setTimeout ( () => document.dispatchEvent(new CustomEvent(Events.CharacterReloaded, {detail: { type, character, callback}})), 1000);
    }

    createCharacter (index = -1, character = "octave")
    {
        this.characterResponse.params.x.gravity = 1.5;

        if (this.anim)
        {
            index = this.characterIndex;


            document.removeEventListener(Events.PlayCharacterAnimation, this.anim.fct1);
            document.removeEventListener(Events.BounceCharacterIn, this.anim.fct2)
            document.removeEventListener(Events.BounceCharacterOut, this.anim.fct3)

            this.anim.removeFromParent();
        }


        let anim = this.anim = this.createAnimations (this.characterProps , index, character);
        anim.fct1  = (e) => this.onPlayAnimation(e, anim);
        anim.fct2  = (e) => this.onBounceCharacterIn(e, anim);
        anim.fct3  = (e) => this.onBounceCharacterOut(e, anim);

        document.addEventListener(Events.PlayCharacterAnimation, anim.fct1);
        document.addEventListener(Events.BounceCharacterIn, anim.fct2)
        document.addEventListener(Events.BounceCharacterOut, anim.fct3)

        return anim;
    }


    createAnim (index = -1, params = "", props, responsive)
    {

        let animation = params.b;

        if (animation === "")
            return;


        let {pKey, pAtlas, pIndex, pResponsive} = this.getCommonsProps(props);

        let strAnimKey = this.getAnimKey(animation);
        let strAtlas = this.getAnimAtlas(animation);
        let objAnimation = [{anim: animation, atlas: `${animation}`, key: `${strAnimKey}`,}]

        let animClass = AnimatedSpriteResponsive;
        let anim = null;

        if (animation === "pluie")
        {
            anim = new Rain( responsive);
        }
        else
        {
            anim = new AnimatedSpriteResponsive(objAnimation, responsive);
        }




        this.addReactiveToEnvironment(anim, {key: animation}, animation, index, `anim-${animation}-${index}`);

        this.arrCurrentElements.push(anim)


        anim.start(animation);
        anim.visible = true;

        anim.startAnimationMovement(animation, params.c);

        return anim;

    }

    getAnimKey (animation)
    {
        if (animation === "papillon")
        {
            return "Papillon_M1_StateA_Speed_Flap_fast__body_12fps"
            //return "ME_papillon_flying"
        }
        else if (animation === "chauve-souris")
        {
            return "ME_chauve-souris_flying"
            //return "ME_papillon_flying"
        }

        return "i_dunno";
    }

    getAnimAtlas (animation)
    {
        if (animation === "papillon")
        {
            return "Papillon_M1_StateA_fast"
            //return "ME_papillon_flying"
        }
        else if (animation === "chauve-souris")
        {
            return "Papillon_M1_StateA_fast"
            //return "ME_papillon_flying"
        }

        return "i_dunno";
    }

    createMaestro ()
    {
        let maestro = this.animMaestro = this.createAnimationsMaestro (this.characterProps);
        // maestro.fct1  = (e) => this.onPlayAnimation(e, maestro);
        // maestro.fct2  = (e) => this.onBounceCharacterIn(e, maestro);
        // maestro.fct3  = (e) => this.onBounceCharacterOut(e, maestro);

        // document.addEventListener(Events.PlayCharacterAnimation, maestro.fct1);
        // document.addEventListener(Events.BounceCharacterIn, maestro.fct2)
        // document.addEventListener(Events.BounceCharacterOut, maestro.fct3)
    }
    async createScene ()
    {

        let {decor, character} = User.getDecorAndCharacter();


        this.prepareOneScreen( { xOffset: 0, scene: `${decor}-intro`})
        this.prepareOneScreen( { xOffset: 1, scene: `${decor}-1`})
        this.prepareOneScreen( { xOffset: 2, scene: `${decor}-2`})
        this.prepareOneScreen( { xOffset: 3, scene: `${decor}-3`})
        this.prepareOneScreen( { xOffset: 4, scene: `${decor}-4`})
        this.prepareOneScreen( { xOffset: 5, scene: `${decor}-5`});
        this.prepareOneScreen( { xOffset: 6, scene: `${decor}-6`});



        this.allAssets.sort ( (a,b) => a.index - b.index);
        let arrItems = this.allAssets;

        let max = arrItems.length;
        for (let i = 0; i < max; i++)
        {
            if (i === 230)
            {
                let a = 1;
            }

            let props = arrItems[i].props;
            let offset = arrItems[i].xOffset;
            let {pKey, pAtlas, pIndex, pResponsive} = this.getCommonsProps(props);

            let key = pKey.val.replace("images/", "");


            // if (key.substring(0, "animations".length) === "animations")
            if (key.indexOf("anim") > -1)
            {
                let responsive = pResponsive.val;

                this.characterResponse = responsive;
                this.characterProps = props;
                this.characterIndex = i;

                let anim = this.createCharacter(i, character)
                // responsive.params.x.gravity = parseFloat(responsive.params.x.gravity) + offset;
                //
                //  let anim = this.anim = this.createAnimations (props, i, character);
                //  anim.fct1  = (e) => this.onPlayAnimation(e, anim);
                //  anim.fct2  = (e) => this.onBounceCharacterIn(e, anim);
                //  anim.fct3  = (e) => this.onBounceCharacterOut(e, anim);
                //
                // document.addEventListener(Events.PlayCharacterAnimation, anim.fct1);
                // document.addEventListener(Events.BounceCharacterIn, anim.fct2)
                // document.addEventListener(Events.BounceCharacterOut, anim.fct3)
                //
                 if (anim !== null)
                    continue;
            }

            let params = this.getParams(props).val;

            if (params && params.a === "Guide")
            {
                let a = 1;

                continue;
            }





            let isAnim = false;

            if (params.b !== "")
            {
                isAnim = ["papillon", "chauve-souris", "pluie"].includes(params.b);
            }

            if (isAnim)
            {
                let a = "break-here";
            }

            let texture  = Library.instance.getTextureFromAtlas(pAtlas.val, pKey.val );

            let responsive = pResponsive.val;

            if (!responsive.params.wasOffsetted)
            {
                responsive.params.x.gravity = parseFloat(responsive.params.x.gravity) + offset;
                responsive.params.wasOffsetted = true;
            }



            let sp;

            if (this.shouldHandleSpriteWithParams(params))
            {
                sp = this.handleSpriteWithParams({texture, key, props}, pAtlas.val, responsive);
            }
            else
            {
                if (isAnim)
                {

                    sp = this.createAnim(i, params, props, responsive);
                }
                else
                {
                    sp = this.addItemToEnvironment({texture, key, props}, pAtlas.val, responsive, i, `${offset}-${i}`);
                }

                sp.layout();


            }

            if (key === "filler.png")
            {
                sp.visible = false;
            }

            if (params && params.a !== "")
            {
                let isEmotion = ["joy", "fear", "anger", "calm"].includes(params.a);

                if (isEmotion)
                {
                    sp.visible = false;
                    this.objEmotions[params.a].push(sp);
                }
            }

            sp.alpha = 0;

            sp.name = `asset-${offset}-${i}-${pAtlas.val}-${pKey.val}`;
            gsap.to(sp, { delay: Math.random() * 1.5, duration: 0.5 + Math.random() * 0.5, alpha: 1, ease:"power1.out"})


            // if (params.a && params.b)
            // {
            //     sp.name = params.a + params.b.toUpperCase();
            //     this.objNamedElements[sp.name] = sp;
            // }
            // else if (params.a)
            // {
            //     sp.name = params.a;
            //     this.objNamedElements[sp.name] = sp;
            // }

            if (params.b !== "" && !isAnim)
            {
                sp.startAnimation(params.b, params.c);
            }

            let arrFilters = [];

            if (params.c && params.c === "1")
            {
                //mt20240521
                //arrFilters.push (this.filter);
            }

            if (params.d && parseFloat(params.d) > 0)
            {
                // let shadow = new DropShadowFilter();
                // shadow.distance = parseFloat(params.d) * 10;
                // shadow.rotation = 225;
                // shadow.blur = 0;
                // shadow.alpha = 0.25;
                // arrFilters.push (shadow);
            }

            let propRotation = this.getProp(props, "rotation");

            if (propRotation)
            {
                let angle = Math.PI / 180 * parseFloat(propRotation.val);
                sp.rotation = angle;
            }

            // if (arrFilters.length > 0)
            // {
            //     sp.filters = arrFilters;
            // }

            //This should only append for stuff like Particle or Animation zone
            if (key.substring(0, "animations".length) === "animations")
            {
                this.manageAnimations (sp ,props);
            }

        }

        let path = document.location.pathname;

        if (path.length > 3)
        {
            this.xOffset  = 1;
            this.x = this.xOffset * -Display.instance.getWidth();

        }

        this.layout();

        //this.backgrounds[0].alpha = 0;
        //gsap.to(this.backgrounds[0], {duration: 1, alpha: 1})


        this.backgrounds.forEach( b => this.addChildAt(b, 0) );

        //let scene = Library.instance.getData("foret-intro");
        //this.tweenBGColor(scene.background.color.default.color, 2500);

        setTimeout ( () => document.dispatchEvent(new CustomEvent(this.bReplace ? Events.SceneReloaded : Events.SceneLoaded)), 1000);

        // let startX = window.innerWidth * (this.xOffset + 0.25)
        // let startY = window.innerHeight * 0.25;
        //
        // let goalX = window.innerWidth * (this.xOffset + 0.5)
        // let goalY = window.innerHeight * 0.5;
        //
        //
        //
        //
        //
        // let diffX = goalX - startX;
        // let diffY = goalY - startY;
        //
        // let angle = Math.atan2(diffY, diffX);
        //
        // let aX = Math.cos(angle) * 100;
        // let aY = Math.sin(angle) * 100;
        //
        // this.addCircle(startX, startY, 0x990000)
        // this.addCircle(goalX, goalY, 0x000099);
        // this.addCircle(startX + aX , startY + aY, 0x000099);
        // this.addCircle(startX + aX , startY - aY, 0x990099);
        // this.addCircle(startX - aX , startY - aY, 0x999900);
        // this.addCircle(startX - aX , startY + aY, 0x009999);
        //
        //
        //
        // this.drawLine(startX, startY, goalX, goalY )


        this.createMaestro ();
    }

    slideDecorTo (xOffset)
    {
        this.xOffset  = xOffset;
        this.x = this.xOffset * -Display.instance.getWidth();


        this.layout();
    }

    addCircle (x, y, color)
    {
        let debug = new PIXI.Graphics();

        debug.beginFill(color, 0.9);

        debug.drawCircle(0,0, 20);

        debug.endFill();

        debug.x = x;
        debug.y = y;


        this.addChild(debug)
    }


    drawLine(x1,y1,x2,y2)
    {
        let debug = new PIXI.Graphics();
        debug.lineStyle(1, 0x000000);
        debug.moveTo(x1, y1);
        debug.lineTo(x2, y2);

        this.addChild(debug);
    }



    onBounceCharacterIn (e, anim, callback)
    {

        let wasVisible = anim.visible;

        anim.visible = true;

        anim.responsive.params.x.gravity = wasVisible ? this.xOffset - 0.05 : this.xOffset + 1.05;

        const {width,height} = Display.getScreenSize();

        anim.bounce(wasVisible ? "right" : "left", 0.55, 2, e.detail.callback);
        anim.layout(width,height);
        //anim.x += win
    }

    onBounceCharacterOut (e, anim, callback)
    {

        let wasVisible = anim.visible;

        anim.visible = true;

        const {width,height} = Display.getScreenSize();

        anim.bounce("left", 0.6, 2, e.detail.callback);
        anim.layout(width,height);
        //anim.x += win
    }

    onPlayAnimation (e, anim)
    {

        const animation = e?.detail?.animation ?? "";

        if (animation !== "")
        {
            anim.start(e.detail.animation);
        }
    }

    async prepareOneScreen (options)
    {
        //this.audio = Library.getAudio("audio");

        let data = this.getData(options.scene);


        let scene = this.sceneData = data.scene;

        //let arrItems = this.getOrderItems(data.items); //that was not working in firefox
        let arrItems = data.items;

        if (!this.objBackground[options.xOffset])
        {
            let bg = new BackgroundMultiplyResponsive({scene, offset: options.xOffset});

            this.addChildAt(bg, 0);
            this.backgrounds.push(bg)
            this.arrCurrentElements.push(bg);

            this.objBackground[options.xOffset] = bg;
        }
        else
        {
            this.objBackground[options.xOffset].alpha = 0.5;
            this.objBackground[options.xOffset].changeScene(scene);
            this.objBackground[options.xOffset].changeEmotion("default");
        }





        // let img  = await this.convertContainerToImage( this.background);
        // document.body.appendChild(img);
        //
        // let t = PIXI.Texture.from(img);




        //this.removeChild(this.background);
        //this.removeChild(this.backgroundColor);


        // let sp = new PIXI.Sprite(t);
        //
        // this.backgroundImageTexture = img;


        let max = arrItems.length;// / 2 >> 0;

        for (let index = 0; index < max; index++)
        {
            let props = arrItems[index];

            this.allAssets.push({index, props, xOffset: options.xOffset});

        }

        //this.layout();

        //
        // setTimeout( async () =>
        //             {
        //                 //in pixi7, convert sprite into texture
        //                 let img  = await this.convertContainerToImage(this);
        //                 document.body.appendChild(img);
        //
        //                 let t = PIXI.Texture.from(img)
        //                 let sp = new PIXI.Sprite(t)
        //                 this.addChild(sp);
        //
        //             }, 2000);


        return;
    }

    //convert container to texture
    getTextureFromContainer (container)
    {
        const bounds = container.getLocalBounds();
        const matrix = new PIXI.Matrix();
        matrix.tx    = -bounds.x;
        matrix.ty    = -bounds.y;

        const renderTexture = PIXI.RenderTexture.create( { width : bounds.width, height : bounds.height } );

        const renderer = PIXI.autoDetectRenderer();
        renderer.render( container, {renderTexture, clear: true, matrix, skipUpdateTransform: false} );

        //return renderTexture.castToBaseTexture();

        let rand = "rand_" + (new Date().getTime()) + "_" + (Math.random() * 0xFFFFFF >> 0);

        PIXI.BaseTexture.addToCache( renderTexture.baseTexture, rand );
        PIXI.Texture.addToCache( renderTexture, rand );

        let t = PIXI.Texture.from(rand);
        return t;
    }

    async convertContainerToImage (container)
    {
        const renderer = PIXI.autoDetectRenderer();
        const image = await renderer.extract.image(container);

        return image;
    }

    getContainerAsTexture (container)
    {
        const bounds = container.getLocalBounds();
        const matrix = new PIXI.Matrix();
        matrix.tx    = -bounds.x;
        matrix.ty    = -bounds.y;

        const renderTexture = PIXI.RenderTexture.create( { width : bounds.width, height : bounds.height } );

        const renderer = PIXI.autoDetectRenderer();
        renderer.render( container, {renderTexture, clear: true, matrix, skipUpdateTransform: false} );

        let rand = "rand_" + (new Date().getTime()) + "_" + (Math.random() * 0xFFFFFF >> 0);

        PIXI.BaseTexture.addToCache( renderTexture.baseTexture, rand );
        PIXI.Texture.addToCache( renderTexture, rand );

        let t = PIXI.Texture.from(rand);
        return t;
    }

    convertCanvasIntoTexture (container)
    {
        const renderer = PIXI.autoDetectRenderer();
        const renderTexture = PIXI.RenderTexture.create({ width: window.innerWidth, height: window.innerHeight });


        renderer.render(container, { renderTexture });

        return renderTexture.castToBaseTexture();

        // Note that you should not create a new renderer, but reuse the same one as the rest of the application.
        // The Sprite in this case will be rendered using its local transform. To render this sprite at 0,0
        // you can clear the transform

        //sprite.setTransform();

        // const renderTexture = new RenderTexture.create({ width: 100, height: 100 });
        //
        // renderer.render(sprite, { renderTexture });
    }
    shouldHandleSpriteWithParams (params)
    {
        return false;
    }

    handleSpriteWithParams (item, atlas = "", responsive)
    {
        return this.addItemToEnvironment(item, atlas, responsive);
    }

    onGoodAnswerAnimationComplete ()
    {

    }

    manageAnimations (sp, props)
    {

    }

    getCommonsProps (props)
    {
        let pKey = props.find( p => p.prop === "atlasKey");
        let pAtlas = props.find( p => p.prop === "atlas");
        let pIndex = props.find( p => p.prop === "index");
        let pResponsive = props.find( p => p.prop === "responsive");

        return {pKey, pAtlas, pIndex, pResponsive};
    }

    getParams (props)
    {
        return props.find( p => p.prop === "params");
    }

    getProp (props, strProp)
    {
        return props.find( p => p.prop === strProp);
    }



    addItemToEnvironment (item, atlas = "", responsive, index, debug = "")
    {
        let sp = new SpriteResponsive(item.texture, responsive, );
        this.addReactiveToEnvironment(sp, item, atlas, index);


        let color = item.props.find( p => p.prop === "color");


        sp.prepareShader(color.val, this.backgroundImageTexture)

        return sp;
    }

    addReactiveToEnvironment (sp, item, atlas, index = -1, isAnim = false)
    {
        let reactive = isAnim ? new AnimatedSpriteReactive(sp) : new SpriteReactive(sp); //this is only for debug purpose

        if (index === -1)
        {
            this.addChild(reactive);
        }
        else
        {
            this.addChildAt(reactive, index);
        }

        this.arrCurrentElements.push(reactive);

        sp.atlas = atlas;
        sp.atlasKey = item.key;


        // const text = new PIXI.Text(debug, {
        //     fontFamily: 'Arial',
        //     fontSize: 24,
        //     fill: 0xff1010,
        //     align: 'center',
        // });
        //
        //
        //
        // sp.addChild(text);


        const {width,height} = Display.getScreenSize();
        reactive.layout(width, height);
    }

    createAnimations (props, index, character)
    {
        let {pKey, pAtlas, pIndex, pResponsive} = this.getCommonsProps(props);

        // let params = this.getParams(props).val;
        //
        //
        // let animation = this.getAnimation({type:"animation", key:"octave-idle-1", animation:"Octave_Iddle1"});
        // let sheet = Library.instance.getTexture("octave-idle-1");

        //let anim = AnimatedSpriteResponsive.fromFrames(sheet.data.animations["Octave_Iddle1"]);
        //let sp2 = PIXI.AnimatedSprite.fromFrames(animation);

        // this.addChild(sp2);
        // sp2.play();

        //capitalize character
        let uCharacter = character.charAt(0).toUpperCase() + character.slice(1);

        if (uCharacter === "Melodie")
        {
            uCharacter = "Mélodie";
        }

        let listAnim = [
            {anim: "idle-1-loop", atlas: `${character}-idle-1-loop`, key: `${uCharacter}_Iddle1_loop`,},
            // {anim: "idle-2", atlas: `${character}-idle-2`, key: `${uCharacter}-Iddle2`,},
            // {anim: "idle-3", atlas: `${character}-idle-3`, key: `${uCharacter}-Iddle3`,},
            {anim: "bounce", atlas: `${character}-bounce`, key: `${uCharacter}_Bounce`,},
            {anim: "calm", atlas: `${character}-calm`, key: `${uCharacter}_Calme`,},
            {anim: "joy", atlas: `${character}-joy`, key: `${uCharacter}_Joie`,},
            {anim: "listen", atlas: `${character}-listen`, key: `${uCharacter}_Listen`,},
            {anim: "fear", atlas: `${character}-fear`, key: `${uCharacter}_Peur`,},
            {anim: "question", atlas: `${character}-question`, key: `${uCharacter}_Question`,},
            {anim: "surprise", atlas: `${character}-surprise`, key: `${uCharacter}_Surprise`,},
            {anim: "sadness", atlas: `${character}-sadness`, key: `${uCharacter}_Tristesse`,},



            ];

        let anim = new AnimatedSpriteResponsive(listAnim, pResponsive.val);

        this.addReactiveToEnvironment(anim, {key: "Octave-Iddle1"}, "octave-idle-1", index, `anim-${index}`);

        this.arrCurrentElements.push(anim)

        anim.start("bounce");
        anim.visible = false;

        return anim;


        let sp = this.getSprite(texture, props);
        this.addChild(sp);

        let element = {};
        if (element.name)
        {
            this.objNamedElements[element.name] = sp;
            sp.name = element.name;
        }


        // let anim = new AnimatedSpriteResponsive()
        // //maestro.name = "Maestro";
        // maestro.ptStart = {x: maestro.responsive.params.x.gravity, y: maestro.responsive.params.y.gravity};
        // maestro.on(Events.MaestroMagic, this.fctEmitMaestroMagic);
        // maestro.once(Events.TalkComplete, this.fctShowGameUI);
        //
        // this.addReactiveToEnvironment(anim, {key: "algue" + params.b}, "");
        //
        // maestro.visible = false;
        //
        // this.objNamedElements["Maestro"] = this.maestro = maestro;
        //
        // let {width, height} = Display.getCanvasSize();
        //
        // maestro.layout(width, height);

        return anim;
    }

    startMaestroTalk ()
    {


        this.maestro.playFrameAt(1)
    }

    endMaestroTalk ()
    {
        console.log("endMaestroTalk");
        console.log("uuid mastro ", this.maestro.uuid)
        this.maestro.stopFrameAt(1)
    }

    slideMaestroIn ()
    {
        this.maestro.visible = true;

        console.log("this.maestro.responsive.params.x", this.maestro.responsive.params.x)

        let me = this;

        this.maestro.responsive.params.x.gravity = this.xOffset - 0.15;
        this.maestro.onUpdateLayout()
        gsap.to(this.maestro.responsive.params.x, {gravity: this.xOffset + 0.15, duration: 0.5, ease: "power3.inOut",onUpdate: () => this.maestro.onUpdateLayout()})
    }
    createAnimationsMaestro (props)
    {
        let {pKey, pAtlas, pIndex, pResponsive} = this.getCommonsProps(props);

        let listAnim = [
            {anim: "talk-1", atlas: `maestro-talk1`, key: `maestro_talk1`,},
            {anim: "talk-2", atlas: `maestro-talk2`, key: `maestro_talk2`,},
            {anim: "talk-3", atlas: `maestro-talk3`, key: `maestro_talk3`,},
        ];

        let maestroResponsive = JSON.parse(JSON.stringify(pResponsive.val));
        maestroResponsive.params.x.gravity = 1.15;
        maestroResponsive.scale.x = 1;
        maestroResponsive.scale.y = 1;

        let anim = this.maestro = new AnimatedSpriteResponsive(listAnim, maestroResponsive);
        console.log("uuid mastro ", this.maestro.uuid)

        this.addReactiveToEnvironment(anim, {key: "maestro-talk1"}, "maestro-talk1", -1, true);

        this.arrCurrentElements.push(anim)

        //anim.start("talk-2", false, null, false);

        this.maestro.start({
                               type:"sequence",
                               animation:["talk-2","talk-3", "talk-2", "talk-1"]
                           }, false, null, false);

        anim.visible = false;
        this.endMaestroTalk();

        window.addEventListener("maestro-talk", this.startMaestroTalk.bind(this));
        window.addEventListener("maestro-end-talk", this.endMaestroTalk.bind(this));

        anim.onComplete = () => console.log("Maestro onComplete")
        anim.onComplete = () => console.log("Maestro onComplete")
        return anim;


        let sp = this.getSprite(texture, props);
        this.addChild(sp);

        let element = {};
        if (element.name)
        {
            this.objNamedElements[element.name] = sp;
            sp.name = element.name;
        }


        // let anim = new AnimatedSpriteResponsive()
        // //maestro.name = "Maestro";
        // maestro.ptStart = {x: maestro.responsive.params.x.gravity, y: maestro.responsive.params.y.gravity};
        // maestro.on(Events.MaestroMagic, this.fctEmitMaestroMagic);
        // maestro.once(Events.TalkComplete, this.fctShowGameUI);
        //
        // this.addReactiveToEnvironment(anim, {key: "algue" + params.b}, "");
        //
        // maestro.visible = false;
        //
        // this.objNamedElements["Maestro"] = this.maestro = maestro;
        //
        // let {width, height} = Display.getCanvasSize();
        //
        // maestro.layout(width, height);

        return anim;
    }

    createAnimations2 (props)
    {
        let {pKey, pAtlas, pIndex, pResponsive} = this.getCommonsProps(props);

        let params = this.getParams(props).val;

        if (params.a === "Maestro")
        {

            let maestro = new Maestro(pResponsive.val);
            maestro.name = "Maestro";
            maestro.ptStart = {x: maestro.responsive.params.x.gravity, y: maestro.responsive.params.y.gravity};
            maestro.on(Events.MaestroMagic, this.fctEmitMaestroMagic);
            maestro.once(Events.TalkComplete, this.fctShowGameUI);

            this.addReactiveToEnvironment(maestro, {key: "algue" + params.b}, "");

            maestro.visible = false;

            this.objNamedElements["Maestro"] = this.maestro = maestro;

            let {width, height} = Display.getCanvasSize();

            maestro.layout(width, height);
        }
        else if (params.a === "Maestro2")
        {
            if (!this.objNamedElements["Maestro"])
                return;

            this.objNamedElements["Maestro"].responsiveSuccess = pResponsive.val;
        }
        else if (params.a === "Animation")
        {
            let animationProp = props.find( p => p.prop === "animationsProp");
            this.objNamedElements["Animation" + params.b] = JSON.parse(animationProp.val)
        }
    }


    getData (strName)
    {
        let scene = Library.instance.getData(strName);

        let data = typeof scene.data === "string" ? JSON.parse(scene.data) : scene.data;


        if (typeof data.data === "string")
            data.data = JSON.parse(data.data);

        return data.data;
    }

    getOrderItems (arrItems)
    {
        return arrItems.sort ( (a,b) =>
        {
            //that is not working in firefox
            let aIndex = a.find( p => p.prop === "index");
            let bIndex = b.find( p => p.prop === "index");
            return aIndex.val + bIndex.val;

            // let aIndex = a.find( p => p.prop === "index").val;
            // let bIndex = b.find( p => p.prop === "index").val;
            //
            // return (aIndex & 1) - (bIndex & 1) || aIndex - bIndex;
        });
    }

    onReplaceComplete ()
    {

        let animalB = this.getElementByName("AnimalB");
        animalB.off(Events.AnimationComplete, this.fctReplaceComplete);

        this.emit(Events.ReplaceComplete);
    }

    showInstructionsMaestro ()
    {

        this.maestro.visible = true;
        setTimeout(() => this.maestro.help(), 1); //we want to wait after layout

        // this.maestro.talk("harmonie_associer");
        this.maestro.once(Events.MaestroMagic, this.fctEmitMaestroMagic )
        this.maestro.once(Events.TalkComplete, this.fctEmitIntroComplete )



        this.arrCurrentElements.push(this.maestro);

        this.layout();
    }

    interruptMaestroGuide ()
    {
        this.fctContinueAfterMaestro = this.continueAfterMaestro.bind(this);
        this.maestro.once(Events.TalkComplete, this.fctContinueAfterMaestro )
        this.maestro.interrupt();
    }


    continueAfterMaestro ()
    {
        console.log("we should call play next or continue or something")
    }

    startMaestroGuide ()
    {
        this.maestro.visible = true;

        this.maestro.index = this.maestro.parent.parent.getChildIndex(this.maestro.parent);

        this.maestro.responsive.params.x.gravity = 0.65;
        this.maestro.responsive.params.y.gravity = 0.65;
        this.maestro.responsive.scale.x = 8;
        this.maestro.responsive.scale.y = 8;

        this.addChild(this.maestro.parent);

        let {width, height} = Display.getCanvasSize();
        this.maestro.layout(width, height);

        this.maestro.addSmallExplosition();
        setTimeout(() => this.maestro.help(), 1);

        this.maestro.once(Events.MaestroMagic, this.fctEmitMaestroMagic )
        this.maestro.once(Events.TalkComplete, this.fctEmitTalkComplete )
    }

    replaceAnimal (index)
    {
        let animalA = this.getElementByName("AnimalA");
        let animalB = this.getElementByName("AnimalB");

        if (index === 1)
        {

            animalA.outro();
            animalB.outro(null, 150);

            animalB.once(Events.UpdatePositionComplete, this.fctReplaceComplete);

        }
        else
        {
            animalA.setColor(this.ColorN, "n");
            animalB.setColor(this.ColorN, "n");
            animalA.intro("n");
            animalB.intro("n", 150);
            animalB.once(Events.UpdatePositionComplete, this.fctReplaceComplete);

            // otarieB.on(Events.AnimationComplete, this.fctReplaceComplete);
        }
    }

    resetMaestro ()
    {
        this.addChildAt(this.maestro.parent, this.maestro.index);

        this.maestro.responsive.params.x.gravity = this.maestro.ptStart.x;
        this.maestro.responsive.params.y.gravity = this.maestro.ptStart.x;
        this.maestro.responsive.scale.x = 1;
        this.maestro.responsive.scale.y = 1;

        let {width, height} = Display.getCanvasSize();
        this.maestro.layout(width, height);
    }


}
